import { DELETE_NOTE, GET_NOTES, POST_NOTE, PUT_NOTE } from '../actionTypes'
import { Note } from '../reducers/note'

export const getNotesAction = (notes: Note[]) => ({ type: GET_NOTES, payload: notes })
export const createNotesAction = (note: Note) => ({ type: POST_NOTE, payload: note })
export const updateNotesAction = (note: Note) => ({ type: PUT_NOTE, payload: note })
export const deleteNotesAction = (noteId: number) => ({ type: DELETE_NOTE, payload: noteId })